import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    modalid: String
  };

  // Stimulus action: the click target carries the modal id, so the method does not read instance state.
  // eslint-disable-next-line class-methods-use-this
  open(e) {
    document.querySelector(`#${e.target.dataset.identifier}`).modal.open();
  };
}
